<template>
  <Modal v-model="model"  sticky reset-drag-position title="自定义添加" @on-cancel="cancel" footer-hide :mask="false" draggable class="definition_config_pop">
    <div class="definition_config_left">
      <div class="font_style_set">字段类型:</div>
      <Select v-model="customType" @on-change="changeType" class="config_content" placeholder="字段类型选择" title="字段类型"  style="width:250px;">
        <Option v-for="(option, index) in customList" :value="option.field_type" :key="index">{{option.field_name}}</Option>
      </Select>
    </div>
    <div class="definition_config_right">
      <div class="font_style_set">模块名称:</div>
      <Select v-model="moduleId" class="config_content" disabled placeholder="模块名称选择" title="模块名称"  style="width:250px;">
        <Option v-for="(option, index) in modularList" :value="option.id" :key="index">{{option.name}}</Option>
      </Select>
    </div>
    <div class="definition_config_left" v-if="moduleId == '2' && groupId">
      <div class="font_style_set">组名称:</div>
      <Select v-model="groupId" class="config_content" disabled placeholder="组名称选择" title="组名称"  style="width:250px;">
        <Option v-for="(option, index) in customGroupList" :value="option.id" :key="index">{{option.groupName}}</Option>
      </Select>
    </div>
    <div class="definition_config_right">
      <div class="font_style_set">显示名称:</div>
      <Input v-model="customName" class="config_content" placeholder="请输入显示名称" title="显示名称" style="width: 250px"/>
    </div>
    <div class="definition_config_left">
      <div class="font_style_set">是否列表显示:</div>
      <RadioGroup v-model="customIsShow" type="button" class="config_content" placeholder="是否显示选择" title="是否列表显示"  style="width:250px;">
        <Radio v-for="(option, index) in judgeList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="definition_config_right">
      <div class="font_style_set">是否唯一:</div>
      <RadioGroup v-model="customIsUnique" type="button" class="config_content" placeholder="是否唯一选择" title="是否唯一"  style="width:250px;">
        <Radio v-for="(option, index) in judgeList" :disabled="customType==='file'" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="definition_config_left">
      <div class="font_style_set">是否必填:</div>
      <RadioGroup v-model="customIsMust" type="button" class="config_content" placeholder="是否必填选择" title="是否必填"  style="width:250px;">
        <Radio v-for="(option, index) in judgeList" :disabled="customType==='file'" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <!-- 工单管理才显示 -->
    <div class="definition_config_right" v-if="moduleId == '2'">
      <div class="font_style_set">是否通用字段:</div>
      <RadioGroup v-model="isGeneralField" type="button" class="config_content" placeholder="是否通用字段" title="模块名称"  style="width:250px;">
        <Radio v-for="(option, index) in judgeList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="definition_config_left">
      <div class="font_style_set">是否提供搜索:</div>
      <RadioGroup v-model="customIsSearch" type="button" class="config_content" placeholder="是否提供搜索选择" title="是否提供搜索"  style="width:250px;">
        <Radio v-for="(option, index) in provideSearch" :disabled="customType==='file'" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
        name: "DefinitionConfigPop",
        props: {
          showDefinitionEdit:Boolean,
          modularCode:String,
          groupId: String,
          customGroupList:Array,
        },
        data(){
          return {
            model:false,
            customName:'',
            customType:'',
            customList:[],
            customIsShow:'1',
            customIsUnique:'0',
            customIsMust:'0',
            customIsSearch:'0',
            customIsSort:'0',
            judgeList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            provideSearch:[{'id':'0','name':'否'},{'id':'1','name':'是'},{'id':'2','name':'高级搜索'}],
            moduleId:'',
            modularList:[{'id':'1','name':'客户管理'},{'id':'2','name':'工单管理'},{'id':'3','name':'服务管理'}],
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            isGeneralField:'0',
          }
        },
        methods:{
          changeType:function(){
            if('file' === this.customType){
              this.customIsUnique = '0';
              this.customIsMust = '0';
              this.customIsSearch = '0';
            }
          },
          initSearchCustom:function () {
            let that=this;
            let param={
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("custom/field/lists.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.customList=res.data.obj;
              if(res.data.obj.length>0){
                that.customType=res.data.obj[0].field_type;
              }
            })
          },
          cancel:function () {
            this.$emit("closeDefinitionEdit",false)
          },
          save:function () {
            let that=this;
            if (!this.moduleId){
              this.$Message.info("请选择模块名称");
              return false;
            }
            if (!this.customType){
              this.$Message.info("请选择字段类型");
              return false;
            }
            if (!this.customName){
              this.$Message.info("请输入显示名称");
              return false;
            }else if(this.customName.length > 19){
              this.$Message.info("显示名称最多仅支持19个字符");
              return false;
            }
            let param={
              moduleId:this.moduleId,
              customName:this.customName,
              customType:this.customType,
              customIsShow:this.customIsShow,
              customIsUnique:this.customIsUnique,
              customIsMust:this.customIsMust,
              customIsSearch:this.customIsSearch,
              customIsSort:this.customIsSort,
              customPosition:'0',
              journalType:"系统管理=>自定义设置=>添加",
              menuId:"3_2-1",
              id:'1',
              groupId: this.groupId ? this.groupId : '-1', //分组id，-1表示后端不验证这个参数，只在客户和服务有效，工单不能传-1
              generalField: this.isGeneralField,
            };
            this.$http.post("custom/insert-field.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Modal.info({
                title:'提示',
                content:"添加成功"
              });
              that.$emit("closeDefinitionEdit",true);
            })
          }
        },
        watch:{
          showDefinitionEdit:function () {
            this.model=this.showDefinitionEdit;
            this.moduleId=this.modularCode;
            if(this.showDefinitionEdit){
              this.customName='';
              this.customIsShow='1';
              this. customIsUnique='0';
              this.customIsMust='0';
              this.customIsSearch='0';
              this.customIsSort='0';
              this.isGeneralField='0';
              this.initSearchCustom();
            }
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DefinitionConfigPop.vue